<template>
  <div class="connect-exchanges-content-verify-steps">
    <img src="@/assets/images/png/verify-steps.png" />
  </div>
</template>

<script>
export default {
  name: "ConnectExchangesContentVerifySteps",
};
</script>

<style lang="scss" scoped>
.connect-exchanges-content-verify-steps {
  img {
    width: 100%;
  }
}
</style>